/** Desktop copies older than this can't use Tea+ until they update. */
export const MIN_DESKTOP_VERSION = '0.5.20';

/** Compares two "1.2.3" versions: negative when a is older, 0 when equal, positive when newer. */
export function compareVersions(a: string, b: string) {
  const pa = a.split('.').map((n) => parseInt(n, 10) || 0);
  const pb = b.split('.').map((n) => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d) return d;
  }
  return 0;
}

/** The desktop version in an Electron user agent ("... TeaPlus/0.5.20 Chrome/..."), if any. */
export function desktopVersionFromUserAgent(ua: string | undefined) {
  return /\bTeaPlus\/(\d+(?:\.\d+){1,3})\b/.exec(ua ?? '')?.[1] ?? null;
}

export const UPDATE_REQUIRED_MESSAGE =
  "Tea+ requires updating. A mandatory update with important fixes has been released, and you can't use Tea+ until you update the app to the latest version. Click Update now in the corner, or download the latest version from app.teaplus.tv/download.";
